import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isTextInput(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.TEXT_INPUT && typeof label === 'string' && typeof value === 'string';
}
function _formatTextInput(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatTextInput(submission) {
  if (isTextInput(submission)) {
    return _formatTextInput(submission);
  }
  return undefined;
}
//# sourceMappingURL=text-input-preview.js.map